export default __webpack_public_path__ + "static/media/welding.fd68d1fd.jpg";